export const PageMode = {
  Login: 'login',
  ResetRequest: 'reset-request',
  ResetEmailSent: 'reset-email-sent',
  ResetPassword: 'reset-password',
  MagicAuth: 'magic-auth',
} as const

export type PageMode = (typeof PageMode)[keyof typeof PageMode]
